import React, { Component } from "react";
import Validator from "validatorjs";
import { Col, Form, Row } from "react-bootstrap";

import { FormControl } from "../../../../facturotopia";
import ObjetoImpDR from "../../support/catalogs/ObjetoImpDR";
import DecimalForGlobals from "../../support/impuestos/DecimalForGlobals";
import ShowAddPagoComprobanteSummary from "./ShowAddPagoComprobanteSummary";
import ComplementoPagosRules from "../../support/rules/ComplementoPagosRules";
import MonedaPOptions from "../../support/catalogs/complementos/pagos/MonedaPOptions";
import FormaDePagoPOptions from "../../support/catalogs/complementos/pagos/FormaDePagoPOptions";
import ComplementoPagosDRRules from "../../support/rules/complementos/pagos/ComplementoPagosDRRules";
import DocumentoRelacionadoImpuestos from "../../create/complementos/pagos/DocumentoRelacionadoImpuestos";

class PagosAddForm extends Component {
  state = {
    data: {},
  };

  getRules(data) {
    let rules = {
      ...ComplementoPagosDRRules({
        ...data,
        Version: this.props.version
      }),
      ...ComplementoPagosRules(data),
      Monto: [
        'required',
        'decimal:6',
        'min:0.000000',
        'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
      ]
    };

    delete rules.TipoCambioDR;

    return rules;
  }

  validate = (data) => {
    const validator = new Validator(data, this.getRules(data));

    validator.check();

    return validator;
  };

  handleOnChange = (value) => {
    const { data } = this.props;

    let newData = {
      ...data,
      ...value,
      ImpuestosDR: value.ObjetoImpDR !== '01' ? data.ImpuestosDR: {},
    };

    if (!!newData.Monto) {
      newData.ImpPagado = this.getImportePagado(newData);

      const { ImpSaldoAnt = 0 } = data;
      const { ImpPagado = 0 } = newData;
      const saldoInsoluto = parseFloat(ImpSaldoAnt) - parseFloat(ImpPagado);

      newData.ImpSaldoInsoluto = DecimalForGlobals.make(saldoInsoluto).toFixed(6);
    }

    const validator = this.validate(newData);

    this.props.onChange({
      data: newData,
      isValid: validator.passes()
    })
  }

  getImportePagado = (data) => {
    return this.isEqualsDivisa(data)
      ? data.Monto || '0.00'
      : DecimalForGlobals.make((data.Monto) / this.getEquivalencia(data)).toFixed(6);
  }

  handleOnImpuestosChange = (impuestos) => {
    const { data } = this.props;

    const newData = {
      ...data,
      ImpuestosDR: {
        ...data.ImpuestosDR,
        ...impuestos,
      }
    }

    const validator = this.validate(newData);

    this.props.onChange({
      data: newData,
      isValid: validator.passes()
    })
  }

  isEqualsDivisa(data) {
    return data.MonedaDR === (data.MonedaP || data.MonedaDR);
  }

  getEquivalencia = (data) => {
    return data.TipoCambioP ?? data.EquivalenciaDR ?? 1;
  }

  render() {
    const { data } = this.props;
    const rules = this.getRules(data);

    const monto = DecimalForGlobals.make((data.ImpSaldoAnt || '0.00') * this.getEquivalencia(data)).toFixed(6)

    return (
      <Form autoComplete="off" className="mt-2">
        <div className="py-3 text-upper">
          <strong>Nuevo pago</strong>
        </div>

        <Row>
          <Col xs="12" sm="6" md="4">
            <FormControl
              type="date-picker"
              label="Fecha de pago"
              name="FechaPago"
              help="Formato día/mes/año"
              maxLength="10"
              autoFocus
              rules={ rules.FechaPago }
              value={ data.FechaPago }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col xs="12" sm="6" md="4">
            <FormControl
              type="text"
              label="Hora de pago"
              name="HoraPago"
              placeholder="Ej. 12:00"
              help="Formato horas:minutos, 24 horas"
              maxLength="5"
              rules={ rules.HoraPago }
              value={ data.HoraPago }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col xs="12" sm="6" md="4">
            <FormControl
              type="select"
              label="Forma de pago"
              name="FormaDePagoP"
              placeholder=""
              help=""
              rules={ rules.FormaDePagoP }
              value={ data.FormaDePagoP }
              options={ FormaDePagoPOptions }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col xs="12" sm="6" md="4">
            <FormControl
              type="select"
              label="Moneda"
              name="MonedaP"
              placeholder=""
              help=""
              rules={ rules.MonedaP }
              value={ data.MonedaP }
              options={ MonedaPOptions }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col xs="12" sm="6" md="4">
            <FormControl
              type="number"
              label="Tipo de cambio"
              name="TipoCambioP"
              placeholder=""
              help=""
              rules={ rules.TipoCambioP }
              value={ data.TipoCambioP }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col xs="12" sm="6" md="4">
            <FormControl
              type="number"
              label="Monto a pagar"
              name="Monto"
              placeholder={ monto }
              help={ this.isEqualsDivisa(data)
                ? ""
                : <><strong>$</strong>{ monto } { data.MonedaP }</>
              }
              rules={ rules.Monto }
              value={ data.Monto }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <div className="py-3">
          <strong className="text-muted">Datos de la operación</strong>
        </div>

        <Row>
          <Col xs="12" sm="6" md="4">
            <FormControl
              type="number"
              label="Número de operación"
              name="NumOperacion"
              placeholder=""
              help=""
              rules={ rules.NumOperacion }
              value={ data.NumOperacion }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col xs="12" sm="6" md="4">
            <FormControl
              type="text"
              label="Cuenta Ordenante"
              name="CtaOrdenante"
              placeholder=""
              help=""
              rules={ rules.CtaOrdenante }
              value={ data.CtaOrdenante }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col xs="12" sm="6" md="4">
            <FormControl
              type="text"
              label="Cuenta Beneficiario"
              name="CtaBeneficiario"
              placeholder=""
              help=""
              rules={ rules.CtaBeneficiario }
              value={ data.CtaBeneficiario }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row>
          <Col xs="12" sm="6" md="4">
            <FormControl type="select"
              label="Objeto Impuesto DR"
              name="ObjetoImpDR"
              placeholder=""
              help={ data.ObjetoImpDR !=='01' ? "Debes agregar al menos un impuesto" : ""}
              rules={ rules.ObjetoImpDR }
              value={ data.ObjetoImpDR }
              options={ ObjetoImpDR }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        { data.MonedaDR !== 'MXN' && (
          <Row className="mt-2">
            <Col sm="6" md="6" className="pb-3">
              <strong>La moneda es diferente de MXN debes corregir la Base y el Importe de los impuestos.</strong>
            </Col>
          </Row>
        )}

        <DocumentoRelacionadoImpuestos
          data={ data }
          onChange={ this.handleOnImpuestosChange }
        />

        <ShowAddPagoComprobanteSummary data={ data } />
      </Form>
    );
  }
}

export default PagosAddForm;
